// Constantes de autenticação

// Tempo antes da expiração para renovar o token (em milissegundos)
export const RENEW_TOKEN_BEFORE_EXPIRY = 5 * 60 * 1000 // 5 minutos

// Chaves do localStorage
export const STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  EXPIRES_IN: 'expiresIn',
  USER: 'user',
  ID_FAZENDA: 'idFazenda',
  NAME_USER_LOGGED: 'nameUserLogged',
  PROFILE_USER_LOGGED: 'profileUserLogged',
  PHONE_IS_CONFIRMED: 'phoneIsConfirmed',
  EMAIL_IS_CONFIRMED: 'emailIsConfirmed',
  FARM_CONFIG: 'farmConfig'
} as const

// Status possíveis do login
export const LOGIN_STATUS = {
  IDLE: '',
  LOADING: 'Carregando...',
  LOGGED: 'Logged',
  ERROR: 'Erro',
  REGISTERING_FARM: 'Cadastrando fazenda...',
  REGISTERING_USER: 'Cadastrando usuário...',
  AUTO_LOGIN: 'Fazendo login automático...',
  RESENDING_CODE: 'Reenviando código...',
  REGISTER_ERROR: 'Erro ao registrar'
} as const
